import {Injectable} from '@angular/core';
import {CommonService} from './common.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor(private commonService: CommonService) { }

  async getUserLogs() {
    try {
      const logsRequest = await this.commonService.getList('consents/logs/user');
      return logsRequest.object;
    } catch (e) {
      throw e;
    }
  }
  async getUserCustomFormsResults(children: any[]) {
    try {
      const logsRequest: any = await this.commonService.insertItem('reports/customFormsReport/child', children);
      return logsRequest.object;
    } catch (e) {
      throw e;
    }
  }

  async getUserAffirmationLogs() {
    try {
      const logsRequest = await this.commonService.getList('affirmations/history');
      return logsRequest.object;
    } catch (e) {
      throw e;
    }
  }

  async getUserAffirmationCollegeLogs() {
    try {
      const logsRequest = await this.commonService.getList('affirmations/logs');
      return logsRequest.object;
    } catch (e) {
      throw e;
    }
  }
}
